module.exports = __webpack_public_path__ + "img/115.46b343ef.jpg";